export const filterDuplicatesById = <T extends { id: string | number }>(
  value: T,
  index: number,
  self: T[]
): boolean => index === self.findIndex((t) => t.id === value.id)
